import Header from "../../../components/Header"
import { HeadingPages } from "../../../components/HeadingPages"
import { Box, Button, Flex, Select, Table, Thead, useToast, Td } from "@chakra-ui/react"
import { TableContainer, Tbody, Tr } from "@chakra-ui/table"
import { Th } from "../../../global/GlobalStyles"
import { api } from "../../../services/api"
import { useForm } from "react-hook-form"
import React from "react"
import { firstLetterUpperCaseAndRestLowerCase } from "../../../utils/capitalFirstLetter"
import { QueryErrorResetBoundary, useQuery } from "react-query"
import { ErrorBoundary } from "react-error-boundary"
import { List } from "./List"
import { Loader } from "../../../components/ComponentLoader/Loader"
import { user } from "../../../helpers/user"

export function RetificacaoLayout() {
  const { register, handleSubmit, watch } = useForm({
    defaultValues: {
      pendente: "S",
    },
  })

  const toast = useToast({
    position: "top",
  })

  console.log(user)

  const { data, isLoading: isSubmitting } = useQuery({
    queryFn: (data) =>
      console.log(data.queryKey[1]) ||
      getAcompanhaRetificacao({
        pendente: data.queryKey[1],
      }),
    queryKey: ["getInfoRetificacaoLayout"],
    onError: (error) => {
      console.log(error)
      toast({
        title: "Erro ao buscar informações de retificação de layout",
        status: "error",
        duration: 9000,
        isClosable: true,
      })
    },
    onSuccess: (data) => {
      console.log(data)
    },
    refetchOnWindowFocus: false,
  })

  async function getAcompanhaRetificacao({ pendente }) {
    const response = await api.get(`/site/v2/fluxo-layout/listar-retificacoes-aprovacao`)

    const formattedData = response.data.map((item) => {
      return {
        ...item,
        codprod: item.codigo_produto,
        nome_vendedor: firstLetterUpperCaseAndRestLowerCase(item.nome_vendedor),
        numero_pedido: item.numero_pedido,
        observacao: firstLetterUpperCaseAndRestLowerCase(
          item.observacao_vendedor?.length > 15
            ? item.observacao_vendedor.substring(0, 15) + "..."
            : item.observacao_vendedor,
        ),
        link_layout: item.link_logo,
        original_obs: item.observacao_vendedor,
      }
    })

    return formattedData
  }

  return (
    <>
      <HeadingPages name="Retificação de Layout" />

      <Box w="100%" h="100vh">
        {/* <Flex
          marginBlock={"1rem"}
          maxW={"500px"}
          w={"100%"}
          mx={"auto"}
          alignItems={"center"}
          justifyContent={"center"}
          gap={2}
          as={"form"}
        >
          <Select {...register("pendente")} w={"100%"} size="sm" fontSize="sm" borderRadius="sm" defaultValue="S">
            <option value="" disabled>
              Selecione
            </option>
            <option value="S">Pendentes</option>
            <option value="N">Finalizados</option>
          </Select>
        </Flex> */}

        <TableContainer textAlign="center" overflowY="auto" overflow="auto" height="calc(100vh - 25rem)" mt="2rem">
          <Table variant="striped" colorScheme="gray" fontSize=".9rem" size={"sm"}>
            <Thead textAlign="center" px="6rem" position="sticky" top="0" zIndex="0">
              <Tr bg="#378BBF" color="white" mx="6rem">
                <Th>Código produto</Th>
                <Th>Vendedor</Th>
                <Th>Numero pedido</Th>
                <Th>Obs</Th>
                <Th>Link Layout</Th>
                <Th>Ações</Th>
              </Tr>
            </Thead>

            <Tbody>
              {isSubmitting && <Loader />}
              <QueryErrorResetBoundary>
                {({ reset }) => (
                  <ErrorBoundary
                    onReset={reset}
                    fallbackRender={({ resetErrorBoundary }) => (
                      <ErrorLayoutBoundary resetErrorBoundary={resetErrorBoundary} />
                    )}
                  >
                    {!isSubmitting && data?.map((item, index) => <List key={index} item={item} />)}

                    {!isSubmitting && data?.length === 0 && (
                      <Tr>
                        <Td colSpan={6} textAlign={"center"}>
                          Nenhuma retificação pendente
                        </Td>
                      </Tr>
                    )}
                  </ErrorBoundary>
                )}
              </QueryErrorResetBoundary>
            </Tbody>
          </Table>
        </TableContainer>
      </Box>
    </>
  )
}

const ErrorLayoutBoundary = ({ resetErrorBoundary }) => (
  <div role="alert">
    <p>Erro ao carregar informações de retificação de layout</p>
    <Button onClick={() => resetErrorBoundary()}>Tentar novamente</Button>
  </div>
)
